/**
 * Bold — hides the description's MORE toggle when the text already fits.
 *
 * Progressive enhancement only: the clamp and the expand/collapse are pure CSS
 * (checkbox + label), so everything still works if this never runs. All this does
 * is measure once the text is actually visible and mark blocks that do not
 * overflow, so a two-line description does not get a pointless MORE link.
 *
 * Measuring is deferred until the containing <details> is open, because a closed
 * one reports scrollHeight 0 - the same trap that makes the theme's own
 * text-truncator disable itself inside an accordion.
 */
(() => {
  const measure = clamp => {
    const text = clamp.querySelector('.bold-clamp__text');
    const state = clamp.querySelector('.bold-clamp__state');
    if (!text || clamp.offsetParent === null) return; // still hidden; try again later

    // Measure against the clamped box, never the expanded one.
    const wasExpanded = state?.checked;
    if (wasExpanded) state.checked = false;

    const fits = text.scrollHeight - text.clientHeight <= 1; // sub-pixel tolerance
    clamp.toggleAttribute('data-bold-fits', fits);

    if (wasExpanded) state.checked = true;
  };

  const measureAll = () => document.querySelectorAll('.bold-clamp').forEach(measure);

  const start = () => {
    measureAll();
    // Re-measure when an accordion opens, which is the first moment the text has a height.
    document.querySelectorAll('details').forEach(d =>
      d.addEventListener('toggle', () => { if (d.open) measureAll(); })
    );
    // Fonts change line height, which changes what fits.
    document.fonts?.ready.then(measureAll);
    window.addEventListener('resize', measureAll);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
